/* session-banner.js — the visible half of the session guard.
 *
 * Whenever the browser is NOT a plain shopper session, this pins a small bar to
 * the bottom of every page saying what mode you are in, what has been blocked,
 * and giving you a one-click EXIT.
 *
 * WHY IT MUST EXIST (contract rule: "loud and unmissable", + the residue exit):
 *   • Before this, the only signal was a one-shot toast you could scroll past,
 *     and there was NO exit anywhere — the adopted identity simply persisted
 *     into the operator's own browsing forever.
 *   • Exit runs SE_Session.end(), which un-stamps the cart FIRST, restores the
 *     operator's own identity from the snapshot taken at begin(), clears the
 *     session's storage, and reloads.
 *
 * Renders NOTHING for a real shopper — zero DOM, zero cost. Self-contained per
 * the isolation principle: reads state only via window.SE_Session.
 */
(function () {
  'use strict';

  if (window.__AGB_sessionBanner) return;
  window.__AGB_sessionBanner = true;

  function boot() {
    var S = window.SE_Session;
    if (!S || S.kind() === 'shopper') return;      // real shopper -> nothing at all

    // PREVIEW THEMES ONLY, deliberately. Preview is where the test personas
    // run, and a staff member browsing the LIVE store has no use for a bar.
    if (!S.isPreview()) return;

    var kind = S.kind();
    var isAssumed = kind === 'assumed';

    var bar = document.createElement('div');
    bar.setAttribute('role', 'status');
    bar.style.cssText = [
      'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483600',
      'display:flex', 'align-items:center', 'gap:12px', 'flex-wrap:wrap',
      'padding:8px 14px', 'font:13px/1.4 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
      'color:#fff', 'background:' + (isAssumed ? '#8f1814' : '#3f4a2e'),
      'box-shadow:0 -2px 12px rgba(0,0,0,.35)'
    ].join(';');

    var label = document.createElement('strong');
    label.style.cssText = 'letter-spacing:.06em;text-transform:uppercase;font-size:11px';
    label.textContent = isAssumed ? 'Viewing as someone else' : 'Team / test session';

    var msg = document.createElement('span');
    msg.style.cssText = 'flex:1 1 auto;min-width:180px;opacity:.92';
    msg.textContent = isAssumed
      ? 'Nothing you do here is saved to their account or to our records.'
      : 'This visit is marked internal, so it stays out of the shopper reports.';

    var count = document.createElement('span');
    count.style.cssText = 'font-variant-numeric:tabular-nums;opacity:.85;font-size:12px';

    function refresh() {
      var n = 0;
      try { n = S.blocked().length; } catch (e) {}
      count.textContent = n ? (n + (n === 1 ? ' action kept private' : ' actions kept private')) : '';
    }
    refresh();
    setInterval(refresh, 2000);

    bar.appendChild(label);
    bar.appendChild(msg);
    bar.appendChild(count);

    // The exit button appears ONLY when there is a snapshot to restore from.
    //
    // A session that was merely RECOGNISED (a staff00- browser that has always
    // been itself) never went through begin(), so end() cannot put anything
    // back — it can only delete the identity and the 365-day cookie, i.e. strip
    // the staff flag that keeps that person's browsing out of the shopper
    // reports. They would have to re-flag from their team link, and it happens
    // in THEIR browser storage, so it cannot be undone from our side.
    // A control that can only destroy is worse than no control, so: no button.
    var canRestore = false;
    try { canRestore = !!(S.canRestore && S.canRestore()); } catch (e) {}

    if (canRestore) {
      var exit = document.createElement('button');
      exit.type = 'button';
      exit.textContent = 'Exit and restore me';
      exit.style.cssText = [
        'flex:0 0 auto', 'cursor:pointer', 'font:inherit', 'font-weight:700',
        'padding:6px 14px', 'border-radius:4px', 'border:1px solid rgba(255,255,255,.5)',
        'background:rgba(255,255,255,.12)', 'color:#fff'
      ].join(';');
      exit.addEventListener('click', function () {
        exit.disabled = true;
        exit.textContent = 'Restoring…';
        try { S.end(); } catch (e) { location.reload(); }
      });
      bar.appendChild(exit);
    }
    (document.body || document.documentElement).appendChild(bar);

    // Keep the page's own bottom-fixed UI (cart bar, cookie notice) clear of it.
    try { document.body.style.paddingBottom = (bar.offsetHeight + 8) + 'px'; } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
